<!--
/*******************************************************************************
*@ 컴포넌트명   : Tab.vue
*@ 컴포넌트설명 :tab 공통컴포넌트
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <div :class="['tabs', bgType?'bg-type':'', cssType==''?'':`--${cssType}`]">
      <button
        v-for="(data, index) in titleList"
        :class="['tab-button', cssType==''?'tab-button--type1':'', currentTab===index?'active':'']"
        @click="tabClick(index)"
        :key="index"
      >
        <i
          v-if="typeof tabIcon == 'object' && !_.isNil(tabIcon[index]) && !_.isEmpty(tabIcon[index])"
          class="icon"
          :class="tabIcon[index]"
        ></i>
        <i
          v-else-if="typeof tabIcon == 'string' && !_.isNil(tabIcon) && !_.isEmpty(tabIcon)"
          class="icon"
          :class="tabIcon"
        ></i>
        {{$t(data)}}
      </button>
      <slot name="other" />
    </div>
    <div v-if="Object.keys($slots).length > 0">
      <div v-for="(content, index) in this.$slots" :key="index">
        <slot v-if="currentTab == index" :name="index"></slot>
      </div>
    </div>
  </article>
</template>
<script>
import { commonProps } from "@/mixins/basicComponent";
export default {
  name: "Tab",
  mixins: [commonProps],
  props: {
    titleList: {
      type: Array,
      required: true,
    },
    bgType: {
      type: Boolean,
      default: false,
    },
    tabIcon: {
      default: "",
    },
  },
  data() {
    return {
      currentTab: 0,
    };
  },
  mounted() {},
  computed: {
    getCurrentTab: {
      get() {
        return this.currentTab;
      },
      set(value) {
        this.$emit("click", value);
        this.currentTab = value;
      },
    },
  },
  methods: {
    /**
     * 탭 선택
     * @param {Number} index 탭 index
     */
    tabClick(index) {
      this.getCurrentTab = index;
    },
  },
};
</script>